import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { POST_PROMPTS, canApplyPrompt } from '../../lib/postPrompts';

@observer
class PostPrompts extends Component {
    applyPrompt = (e) => {
        const { id } = e.target.closest('button').dataset;
        const { articleStore } = this.props.stores;
        const { newArticle } = articleStore;
        if (!canApplyPrompt(newArticle.ingress)) {
            return;
        }
        const prompt = POST_PROMPTS.find(p => p.id === id);
        if (!prompt) {
            return;
        }
        articleStore.updateObjectKeyValue('newArticle', 'ingress', prompt.prefill);
        articleStore.updateObjectKeyValue('newArticle', 'background', prompt.background);
        const textarea = document.querySelector('.article-composer textarea[data-field="ingress"]');
        if (textarea) {
            textarea.focus();
        }
    }

    render() {
        const { articleStore } = this.props.stores;
        const { newArticle } = articleStore;
        const locked = !canApplyPrompt(newArticle.ingress);
        if (locked) {
            return null;
        }
        return (
            <div class='d-flex flex-row flex-nowrap overflow-auto gap-2 px-3 pt-3'>
                {POST_PROMPTS.map(prompt => {
                    const isActive = (newArticle.ingress || '') === prompt.prefill;
                    return (
                        <button
                            type='button'
                            key={prompt.id}
                            class={`btn btn-sm rounded-pill text-nowrap ${isActive ? 'btn-secondary' : 'btn-outline-secondary'}`}
                            data-id={prompt.id}
                            onClick={this.applyPrompt}
                        >
                            <Text id={`article.${prompt.textKey}`}>{prompt.defaultText}</Text>
                        </button>
                    );
                })}
            </div>
        );
    }
}

export default PostPrompts;
